import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

export class SpaContainer extends Component {
  state = {
    hasCompleted: false,
    lastPageSeen: "",
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.onComplete &&
      nextProps.activeView ==
        this.props.children[this.props.children.length - 1].key &&
      !this.state.hasCompleted
    ) {
      this.setState({ hasCompleted: true })
      this.props.onComplete(
        this.props.children.length > 2 &&
          nextProps.previousView !=
            this.props.children[this.props.children.length - 2].key
      )
    }
    if (
      this.props.onPageChange &&
      nextProps.previousView != nextProps.activeView &&
      this.state.lastPageSeen != nextProps.activeView
    ) {
      this.setState({ lastPageSeen: nextProps.activeView })
      this.props.onPageChange(nextProps.previousView, nextProps.activeView)
    }
  }

  render() {
    return (
      <>
        {this.props.children.filter(view => {
          return view.key === this.props.activeView
        })}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeView: state.activeView.activeView,
    previousView: state.activeView.previousView,
  }
}

export default connect(mapStateToProps)(SpaContainer)

SpaContainer.propTypes = {
  activeView: PropTypes.string,
  previousView: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
  onComplete: PropTypes.func,
  onPageChange: PropTypes.func,
}
